const fitnessDevice = (function ($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            buttons: {
                purchaseDevice: '.vds-button-purchase-device',
                disabledPurchaseButton: '#partner-disabled-purchase-button',
                linkButton: '#link-fitness-device',
                unlinkButton: '#partner-header-unlink-button',
                microFlagOverlay: '.vds-partner-header__ctas .vds-micro-flag-overlay',
                emailValidationLink: '#link-email-validation',
                termsConditionsValidationLink: '#link-termsandconditions-validation',
                emailTextBox: '#link-email-address'
            }
        },
        func: {
            init: function () {
                $(self.elements.buttons.microFlagOverlay).hide();
                $(self.elements.buttons.emailValidationLink).hide();
                $(self.elements.buttons.termsConditionsValidationLink).hide();

                if ($(self.elements.buttons.disabledPurchaseButton).length > 0) {
                    $(self.elements.buttons.purchaseDevice).addClass('vds-button--disabled');
                }

                if ($(self.elements.buttons.unlinkButton).length > 0) {
                    $(self.elements.buttons.microFlagOverlay).show();
                }
            },
            bindings: function () {
                $(self.elements.buttons.linkButton).on('click', self.func.handleSignUpButtonClick);
            },
            handleSignUpButtonClick: function () {
                $(self.elements.buttons.emailValidationLink).hide();
                $(self.elements.buttons.termsConditionsValidationLink).hide();
                const emailId = $(self.elements.buttons.emailTextBox).val();

                if (emailId === '') {
                    $(self.elements.buttons.emailValidationLink).show();
                    return false;
                }

                if ($('.checkbox-guard:checked').length !== $('.checkbox-guard').length) {
                    $(self.elements.buttons.termsConditionsValidationLink).show();

                    return false;
                }
                return true;
            }
        }
    };

    return {
        init: self.func.init,
        bindings: self.func.bindings
    };
})(window.jQuery);

$('document').ready(function () {
    if ('garmin' === $('#page-data').data('feature')
        || 'polar' === $('#page-data').data('feature')
        || 'withings' === $('#page-data').data('feature')
        || 'fitbit' === $('#page-data').data('feature')) {
        fitnessDevice.bindings();
        fitnessDevice.init();
    }
});
